import styled from 'styled-components';

import { Button, Menu as MenuGP } from '@gympass/yoga';

export const IconButton = styled(Button.Icon)`
  background-color: ${({ theme }) => theme.yoga.colors.white};

  :active {
    background-color: ${({ theme }) => theme.yoga.colors.disabled};
  }

  :not([disabled]):hover,
  :not([disabled]):focus {
    box-shadow: none;
  }
`;

export const MenuItem = styled(MenuGP.Item)`
  color: ${({ theme }) => theme.yoga.colors.primary};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  height: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
`;
